import * as moment from 'moment';

export class Injury {
    id: number;
    playerId: number;
    begin: moment.Moment;
    end: moment.Moment;
    type: string;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/injury.model.ts